<script setup>
import { onMounted, onBeforeUnmount } from 'vue'

import Button from '@/components/Button.vue'

const props = defineProps({
  show: { type: Boolean, default: false },
  title: { type: String, default: '' },
  description: { type: String, default: '' },
})

const emit = defineEmits(['close'])

const onKeydown = e => {
  if (e.key === 'Escape' && props.show) emit('close')
}

onMounted(() => document.addEventListener('keydown', onKeydown))
onBeforeUnmount(() => document.removeEventListener('keydown', onKeydown))
</script>

<template>
  <teleport to="body">
    <div
      v-if="show"
      class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-n-alpha-black2 backdrop-blur-sm"
      @click.self="emit('close')"
    >
      <div
        class="relative max-h-full overflow-auto shadow-md bg-n-alpha-3 backdrop-blur-[100px] rounded-xl w-[37.5rem]"
      >
        <Button
          slate
          ghost
          icon="i-lucide-x"
          class="absolute z-10 top-2 ltr:right-2 rtl:left-2"
          :aria-label="'close'"
          @click="emit('close')"
        />
        <div class="flex flex-col h-auto overflow-auto">
          <div class="flex flex-col items-start px-8 pt-8 pb-0">
            <h2 class="text-base font-semibold leading-6 text-n-slate-12">
              {{ title }}
            </h2>
            <p
              v-if="description"
              class="w-full mt-2 text-sm leading-5 break-words text-n-slate-11"
            >
              {{ description }}
            </p>
          </div>
          <div class="px-8 pt-5 pb-8">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>
